(() => {
  'use strict';

  if (window.FlyAndBagWishlistFlyAnimation) return;
  window.FlyAndBagWishlistFlyAnimation = true;

  const TOGGLE_SELECTOR = '[data-flyandbag-wishlist-toggle]';
  const HEADER_HEART_SELECTOR = '[data-flyandbag-wishlist-header-link]';
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function installStyles() {
    if (document.getElementById('FlyAndBagWishlistFlyAnimationStyles')) return;

    const style = document.createElement('style');
    style.id = 'FlyAndBagWishlistFlyAnimationStyles';
    style.textContent = `
      .flyandbag-wishlist-flyer {
        position: fixed;
        z-index: 10000;
        display: grid;
        overflow: hidden;
        place-items: center;
        border: 1px solid rgba(255, 79, 179, 0.35);
        border-radius: 16px;
        background: #ffffff;
        box-shadow: 0 16px 38px rgba(27, 31, 59, 0.28);
        pointer-events: none;
        will-change: transform, opacity;
      }

      .flyandbag-wishlist-flyer img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .flyandbag-wishlist-flyer__heart {
        width: 54%;
        height: 54%;
        fill: #ff4fb3;
        stroke: #ff4fb3;
        stroke-width: 1.6;
      }

      .flyandbag-wishlist-header-link.is-catching {
        animation: flyandbag-wishlist-catch 520ms cubic-bezier(.2, .9, .25, 1.35);
      }

      .flyandbag-wishlist-header-link.is-catching .flyandbag-wishlist-heart-shape {
        fill: var(--flyandbag-pink, #ff4fb3);
        stroke: var(--flyandbag-pink, #ff4fb3);
      }

      .flyandbag-wishlist-header-count.is-bumping {
        animation: flyandbag-wishlist-badge-bump 480ms cubic-bezier(.2, .9, .25, 1.45);
      }

      @keyframes flyandbag-wishlist-catch {
        0% { transform: scale(1) rotate(0deg); }
        35% { transform: scale(.82) rotate(-9deg); }
        68% { transform: scale(1.3) rotate(7deg); }
        100% { transform: scale(1) rotate(0deg); }
      }

      @keyframes flyandbag-wishlist-badge-bump {
        0% { transform: scale(.4); }
        55% { transform: scale(1.45); }
        100% { transform: scale(1); }
      }

      @media (prefers-reduced-motion: reduce) {
        .flyandbag-wishlist-flyer { display: none !important; }
        .flyandbag-wishlist-header-link.is-catching,
        .flyandbag-wishlist-header-count.is-bumping { animation: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function getSourceImage(button) {
    const card = button.closest('.resource-card, .product-card, [data-resource-type="product"]');
    if (card) {
      const image = card.querySelector('img');
      if (image) return image;
    }

    return document.querySelector(
      '.product-information__media img, .product-gallery img, main [data-product-media] img, main img'
    );
  }

  function makeFlyer(button) {
    const sourceImage = getSourceImage(button);
    const sourceRect = (sourceImage || button).getBoundingClientRect();
    const size = Math.max(46, Math.min(76, sourceRect.width * 0.24 || 60));
    const flyer = document.createElement('div');
    flyer.className = 'flyandbag-wishlist-flyer';
    flyer.style.width = `${size}px`;
    flyer.style.height = `${size}px`;
    flyer.style.left = `${sourceRect.left + sourceRect.width / 2 - size / 2}px`;
    flyer.style.top = `${sourceRect.top + sourceRect.height / 2 - size / 2}px`;

    const imageUrl = button.dataset.productImage || sourceImage?.currentSrc || sourceImage?.src || '';
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.decoding = 'async';
      flyer.appendChild(image);
    } else {
      flyer.innerHTML = `
        <svg class="flyandbag-wishlist-flyer__heart" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"></path>
        </svg>
      `;
    }

    document.body.appendChild(flyer);
    return { flyer, size };
  }

  function celebrateTarget(target) {
    target.classList.remove('is-catching');
    void target.offsetWidth;
    target.classList.add('is-catching');

    const badge = target.querySelector('[data-flyandbag-wishlist-count]');
    if (badge) {
      badge.classList.remove('is-bumping');
      void badge.offsetWidth;
      badge.classList.add('is-bumping');
    }

    window.setTimeout(() => {
      target.classList.remove('is-catching');
      badge?.classList.remove('is-bumping');
    }, 560);
  }

  function animateToHeader(button) {
    const target = document.querySelector(HEADER_HEART_SELECTOR);
    if (!target) return;

    if (REDUCED_MOTION.matches || typeof Element.prototype.animate !== 'function') {
      celebrateTarget(target);
      return;
    }

    const targetRect = target.getBoundingClientRect();
    const { flyer, size } = makeFlyer(button);
    const flyerRect = flyer.getBoundingClientRect();
    const startX = flyerRect.left;
    const startY = flyerRect.top;
    const targetX = targetRect.left + targetRect.width / 2 - size / 2;
    const targetY = targetRect.top + targetRect.height / 2 - size / 2;
    const dx = targetX - startX;
    const dy = targetY - startY;
    const lift = Math.min(130, Math.max(55, Math.abs(dy) * 0.16));

    const animation = flyer.animate(
      [
        { transform: 'translate3d(0, 0, 0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        {
          transform: `translate3d(${dx * 0.3}px, ${dy * 0.14 - lift}px, 0) scale(.92) rotate(-7deg)`,
          opacity: 1,
          offset: 0.34,
        },
        {
          transform: `translate3d(${dx * 0.76}px, ${dy * 0.68 - lift * 0.25}px, 0) scale(.48) rotate(8deg)`,
          opacity: .9,
          offset: 0.76,
        },
        {
          transform: `translate3d(${dx}px, ${dy}px, 0) scale(.12) rotate(0deg)`,
          opacity: .15,
          offset: 1,
        },
      ],
      {
        duration: 760,
        easing: 'cubic-bezier(.22, .72, .24, 1)',
        fill: 'forwards',
      }
    );

    animation.finished
      .catch(() => {})
      .finally(() => {
        flyer.remove();
        celebrateTarget(target);
      });
  }

  function handleClick(event) {
    const button = event.target.closest(TOGGLE_SELECTOR);
    if (!button || button.getAttribute('aria-pressed') === 'true') return;

    installStyles();
    window.requestAnimationFrame(() => animateToHeader(button));
  }

  installStyles();
  document.addEventListener('click', handleClick, true);
})();
